import { BrowserCacheLocation, type Configuration } from "@azure/msal-browser";

/**
 * Регистрация приложения в Azure AD — та же, что у staffing. Это не секреты: SPA ходит по PKCE
 * без client secret, поэтому значения по умолчанию лежат здесь, а стенд может переопределить их через env.
 */
const DEFAULT_MSAL_CLIENT_ID = "6a6ac7a7-2ae2-419b-bf95-e6b83652d36b";
const DEFAULT_MSAL_AUTHORITY = "https://login.microsoftonline.com/313bbf33-dd44-4610-a6b1-78d4e29b6d0f";
const DEFAULT_MSAL_API_SCOPE = "api://436b064b-6c84-4cc8-bcd3-4380d08e23e1/access_as_user";

export const MSAL_CLIENT_ID = import.meta.env.VITE_MSAL_CLIENT_ID || DEFAULT_MSAL_CLIENT_ID;
export const MSAL_AUTHORITY = import.meta.env.VITE_MSAL_AUTHORITY || DEFAULT_MSAL_AUTHORITY;
export const MSAL_API_SCOPE = import.meta.env.VITE_MSAL_API_SCOPE || DEFAULT_MSAL_API_SCOPE;

/** Scope нашего API: с ним и логинимся, и получаем Azure-токен для всех запросов и обмена. */
export const MSAL_TOKEN_REQUEST = { scopes: [MSAL_API_SCOPE] };

export const getMsalConfiguration = (): Configuration => ({
  auth: {
    clientId: MSAL_CLIENT_ID,
    authority: MSAL_AUTHORITY,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  // localStorage, а не sessionStorage: с redirect-флоу иначе каждая новая вкладка требовала бы входа заново
  cache: { cacheLocation: BrowserCacheLocation.LocalStorage },
});
